import http from '@/middleware';

export const caliperApi = {
    async getSummaryReportByDate(filters) {
        // idioma para la notificación del reporte diferido
        const lang = localStorage.getItem("locale");
        const result = await http.post('/api/caliper/reportCustomTime', { ...filters, lang });
        return result.data;
    },

    async pressureThingDataByDate(filters) {
        const result = await http.post('/api/caliper/pressureThingDataByDate', filters);
        return result.data;
    },

    async getSummaryReportFixedRange(filters) {
        const result = await http.post("/api/caliper/reportFixedRange", filters);
        return result.data;
    },

    async getThingPositions(idThing, from, to) {
        const result = await http.post("/api/caliper/positionByIdThing", { idThing, from, to });
        return result.data;
    }
}